import React from 'react';
import { Select } from 'antd';

export const aSearchElements = [
  {
    label: 'Folio',
    name: 'folio',
    type: 'input',
  },
  {
    label: 'Serie',
    name: 'serie',
    type: 'input',
    whitelist: false,
  },
  {
    label: 'Fecha',
    name: 'created_at',
    type: 'date',
  },
  {
    label: 'Estatus',
    name: 'status',
    placeholder: 'Todos',
    type: 'select',
    values: () => (
      <>
        <Select.Option value={1}>Timbrada</Select.Option>
        <Select.Option value={0}>Pendiente</Select.Option>
        <Select.Option value={2}>Cancelada</Select.Option>
      </>
    ),
  },
];

export const oInitState = {
  folio: '',
  serie: '',
  client_id: '',
  status: undefined,
};
